import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CloseButton,
  ProgressBar,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { FaUpload } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { setIsUploadFile } from "../redux/slice/CaseHeaderSlice";
import { RootState } from "../redux/Store";

export interface UploadStatus {
  fileName: string;
  progress: number;
  isUploading: boolean;
}

interface UploadStatusFloatingIconProps {
  uploadStatuses: Record<string, any>;
  onCancelUpload: (fileId: string) => void;
  isUpload?: boolean;
  recordActiveTab?: string;
  activeTab?: string;
  isAllCancel?: boolean;
}

interface FloatingUploadStatusProps {
  filename: string;
  progress: number;
  statusMessage: string;
  onCancel: () => void;
  isUpload?: boolean;
}

const FloatingUploadStatus: React.FC<FloatingUploadStatusProps> = ({
  filename,
  progress,
  statusMessage,
  onCancel,
  isUpload = false,
}) => {
  const displayName = Array.isArray(filename) ? filename.join(", ") : filename;
  return (
    <Card
      className="mb-2 shadow-sm"
      style={{ borderRadius: "8px", position: "relative" }}
    >
      <Card.Body style={{ padding: "10px" }}>
        <div className="d-flex justify-content-between align-items-start mb-2">
          <Card.Title
            as="h6"
            className="mb-0 text-truncate"
            style={{ maxWidth: "85%" }}
          >
            <OverlayTrigger
              placement="auto"
              delay={{ show: 200, hide: 10 }}
              overlay={
                <Tooltip
                  id={`file-tooltip-${displayName}`}
                  style={{ backgroundColor: "#b3e0ff" }}
                >
                  {displayName}
                </Tooltip>
              }
            >
              <span
                style={{
                  cursor: "pointer",
                  display: "inline-block",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                }}
              >
                {displayName}
              </span>
            </OverlayTrigger>
          </Card.Title>
          {isUpload ? (
            <Button
              variant="danger"
              className="border-0 bg-transparent mx-1 px-1"
              style={{ marginTop: "-5%" }}
              onClick={onCancel}
            >
              <span className="material-icons color_brand mx-1">close</span>
            </Button>
          ): ("")}
        </div>

        <Card.Text className="text-muted mb-2" style={{ fontSize: "0.85rem" }}>
          {isUpload ? "Uploading file..." : "Downloading file..."}
        </Card.Text>

        <ProgressBar
          now={progress}
          label={`${Math.round(progress)}%`}
          variant="info"
          style={{ height: "12px", fontSize: "10px" }}
        />
      </Card.Body>
    </Card>
  );
};

const UploadStatusFloatingIcon: React.FC<UploadStatusFloatingIconProps> = ({
  uploadStatuses,
  onCancelUpload,
  isUpload,
  recordActiveTab,
  activeTab,
  isAllCancel,
}) => {
  const dispatch = useDispatch();
  const { isUploadFile, isCancelFiles } = useSelector((state: RootState) => state.caseHeader);
  const uploadingEntries = Object.entries(uploadStatuses).filter(
    ([, status]) => status.isUploading
  );
 
  useEffect(() => {
    if (isUpload && uploadingEntries.length > 0) {
      dispatch(setIsUploadFile(true));
    } else {
      dispatch(setIsUploadFile(false));
    }
  }, [uploadingEntries.length, dispatch]);

  if (uploadingEntries.length === 0) return null;

  return (
    <div style={{ position: "fixed", top: "20px", right: "20px", zIndex: 9999 }}>
      {/* Upload Cards Container */}
      <div
        style={{
          background: "#f8f9fa",
          border: "1px solid #ddd",
          borderRadius: "8px",
          padding: "10px",
          width: 260,
          maxHeight: 300,
          overflowY: "auto",
        }}
      >
        {/* Upload Cards */}
        {uploadingEntries.map(([id, status]) => (
          <div key={id} style={{ marginBottom: 10 }}>
            <FloatingUploadStatus
              filename={status.fileName}
              progress={status.progress}
              statusMessage="Uploading file..."
              onCancel={() => onCancelUpload(id)}
              isUpload={isUpload}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default UploadStatusFloatingIcon;
